import axios from "src/utils/axios";
import { createSlice } from "@reduxjs/toolkit";

// Rediseño Informes empleados · slice que sirve daily-breakdown +
// weekly-summary al Panel, Fichajes, Análisis y el drawer individual.
// Cachea por query-string (`${from}|${to}|${employeeId ?? ""}`) para
// evitar refetches al alternar entre tabs con el mismo rango.

const initialState = {
  isLoading: false,
  error: null,
  daily: [],
  weekly: [],
  lastQuery: null, // `${desde}|${hasta}|${employeeId ?? ""}`
};

const slice = createSlice({
  name: "employeeReports",
  initialState,
  reducers: {
    startLoading(s) { s.isLoading = true; s.error = null; },
    hasError(s, a) { s.isLoading = false; s.error = a.payload; },
    setDaily(s, a) {
      s.isLoading = false;
      s.daily = a.payload.items || [];
      s.lastQuery = a.payload.query;
    },
    setWeekly(s, a) {
      s.weekly = a.payload || [];
    },
    reset(s) {
      s.daily = [];
      s.weekly = [];
      s.lastQuery = null;
      s.error = null;
    },
  },
});

export default slice.reducer;
export const { reset: resetReports } = slice.actions;

const buildQ = (desde, hasta, employeeId) =>
  `${desde}|${hasta}|${employeeId ?? ""}`;

export function fetchDailyBreakdown({ desde, hasta, employeeId } = {}, force = false) {
  return async (dispatch, getState) => {
    if (!desde || !hasta) return;
    const q = buildQ(desde, hasta, employeeId);
    if (!force && getState().employeeReports.lastQuery === q) return;
    dispatch(slice.actions.startLoading());
    try {
      const params = { desde, hasta };
      if (employeeId) params.employeeId = employeeId;
      const res = await axios.get("employeeReports/daily-breakdown", { params });
      dispatch(slice.actions.setDaily({ items: res.data || [], query: q }));
    } catch (err) {
      dispatch(slice.actions.hasError(err?.message || "Error"));
    }
  };
}

export function fetchWeeklySummary({ desde, hasta } = {}) {
  return async (dispatch) => {
    if (!desde || !hasta) return;
    try {
      const res = await axios.get("employeeReports/weekly-summary", {
        params: { desde, hasta },
      });
      dispatch(slice.actions.setWeekly(res.data || []));
    } catch (err) {
      dispatch(slice.actions.hasError(err?.message || "Error"));
    }
  };
}

/**
 * Descarga el CSV del tab especificado directamente al disco del usuario.
 * Blob + link temporal — no requiere touchear el DOM más allá del click().
 */
export function downloadReportCsv({ tab, desde, hasta, employeeId }) {
  return async () => {
    const params = { tab, desde, hasta };
    if (employeeId) params.employeeId = employeeId;
    const res = await axios.get("employeeReports/csv", {
      params,
      responseType: "blob",
    });
    const blob = new Blob([res.data], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `informe-${tab}-${desde}_${hasta}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
}
